import { useState } from "react";
import { PasswordInput } from "../components/forms/Inputs";
import { Form } from "../components/forms/Form";
import { useApi } from "../hooks/useApi";
import { Button } from "../components/layout/Button";
import { useNavigate } from "react-router-dom";
import { useTranslations } from "../layers/Localization";
import { Row } from "../components/crud/DetailPage";
import { FaBan, FaSave } from "react-icons/fa";

export function ChangePassword() {
    const [oldPassword, setOldPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [newPassword2, setNewPassword2] = useState("")
    const [error, setError] = useState("")

    const api = useApi()
    const navigate = useNavigate()
    const t = useTranslations()

    const submit = async () => {
        try {
            await api.post('/change-password', { oldPassword, newPassword })
            navigate('/')
        } catch (err) {
            if (err?.response?.status === 400) {
                setError(t('Password incorrect'))
            } else {
                throw err
            }
        }
    }

    return <Form onSubmit={submit} className="w-full basis-3/4">
        <h1 className="mb-5 font-bold text-2xl">{t('Modifier le mot de passe')}</h1>
        <div className="bg-white border border-gray-300 rounded-xl p-5">
            <Row>
                <PasswordInput className="grow" value={oldPassword} onChange={setOldPassword} required label={t("Ancien mot de passe")} invalid={error} onFocus={() => setError(null)} />
                <PasswordInput className="grow" value={newPassword} onChange={setNewPassword} required label={t("Nouveau mot de passe")} />
                <PasswordInput className="grow" value={newPassword2} onChange={setNewPassword2} required label={t("Répétez le nouveau mot de passe")} invalid={newPassword !== newPassword2 && t("Les mots de passe ne correspondent pas")} />
            </Row>
            <Row className="mt-5">
                <Button gray icon={<FaBan />} onClick={() => navigate('/')}>{t('Cancel')}</Button>
                <Button icon={<FaSave />} submit>{t('Sauvegarder')}</Button>
            </Row>
        </div>
    </Form>
}